
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Client, IContactCreateModel, ContactCreateModel } from '@/services/api.service';
@Component
export default class AddContact extends Vue {

  public name: string = '';
  public position: string = '';
  public email: string = '';
  public phone: string = '';
  public mobile: string = '';

  @Prop() private gidClient!: string;

  public clear() {
    // reset the fields

    this.name = '';
    this.position = '';
    this.email = '';
    this.phone = '';
    this.mobile = '';

  }

  private cancelAddContact() {
    this.$emit('add-contact-cancelled');
  }

  private addContact() {
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    const createModel: IContactCreateModel = {
      name: this.name,
      phone: this.phone,
      mobile: this.mobile,
      email: this.email,
      position: this.position
    };

    console.log('Adding contact to clientgid:' + this.gidClient);
    clientService.createContact(this.gidClient, new ContactCreateModel(createModel)).then((data) => {
      // Route to the edit client screen?
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Contact ' + this.name + ' created successfully');
      this.$emit('contact-added', data);
      this.clear();
    });
  }
}
